<router-outlet>
  <app-loader [showLoader]="loader" [signupMessage]="signUp"></app-loader>
</router-outlet>
